import React, { useState, useMemo, useRef, useEffect } from "react";
import { getColumns, data } from "./utils";
import { ExpandableTable } from "@components/ExpandebleTable";
import styles from "./styles.module.scss";
import { GearIcon } from "@radix-ui/react-icons";
import { SettingsModal } from "./settings-modal";
import { defaultSettings, TableSettings } from "./model";

export interface MarketplaceTableProps {
  fromCanvas?: boolean;
}

export const MarketplaceTable: React.FC<MarketplaceTableProps> = ({
  fromCanvas = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useState<TableSettings>(defaultSettings);
  const [height, setHeight] = useState(0);

  const handleToggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleSettingsChange = (newSettings: TableSettings) => {
    setSettings(newSettings);
  };

  useEffect(() => {
    if (!fromCanvas) return;
    if (containerRef.current) {
      const height = containerRef.current.offsetHeight;
      setHeight(height === 70 ? 500 : height);
    }
  }, [containerRef.current?.offsetHeight]);

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      switch (item.key) {
        case "1":
          return settings.visibleChannels.amazonUSA;
        case "2":
          return settings.visibleChannels.shopify;
        case "3":
          return settings.visibleChannels.tiktokShop;
        default:
          return true;
      }
    });
  }, [settings.visibleChannels]);

  const columns = getColumns(handleToggleModal, settings.visibleMetrics);

  return (
    <div className={styles.customTableWrapper} ref={containerRef}>
      <button className={styles.toggleButton} onClick={handleToggleModal}>
        <GearIcon className={styles.icon} />
      </button>
      <ExpandableTable
        columns={columns}
        data={filteredData}
        scroll={{ x: "max-content", y: `${fromCanvas ? height - 100 : 600}px` }}
        className="marketplace-table"
      />
      <SettingsModal
        isOpen={isOpen}
        onClose={handleToggleModal}
        settings={settings}
        onSettingsChange={handleSettingsChange}
      />
    </div>
  );
};
